import { render, staticRenderFns } from "./PazienteDeviceList.vue?vue&type=template&id=7a7e3d1a"
import script from "./PazienteDeviceList.vue?vue&type=script&lang=js"
export * from "./PazienteDeviceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports